<template>
    <tr :key="uploaded.id" style="cursor: pointer">
        <td class="text-left">
          {{ this.uploadedDate }}
        </td>
        <td class="text-left">
         {{ this.uploadedName }}
        </td>
        <td class="text-left">
           {{ uploaded.content_type }}
        </td>
        <td class="text-left">
            {{ uploaded.encoding }}
        </td>
        <td class="text-left">
          <v-icon
          :color="determineActiveState === 1 ? 'green' : 'red'">
             {{ determineActiveState === 1 ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </td>
      <td class="text-right">
        <v-icon @click="editClicked" color="#D22321">mdi-pencil</v-icon>
        <v-icon @click="deleteClicked" color="#D22321">delete</v-icon>
      </td>
    </tr>
</template>

<script>
    import timeformatter from "@/utils/timeformatter";

    export default {
        name: 'uploaded-row',
        props: ['uploaded'],
        data () {
            return {
            }
        },
        computed: {
            uploadedDate() {
              return this.uploaded ? timeformatter.format(this.uploaded.upload_date) : ''
            },
            uploadedName () {
                return this.uploaded ? this.uploaded.endpoint.name : ''
            },
            determineActiveState () {
              return this.uploaded ? this.uploaded.active ? 1 : 0 : -1
            }
        },
        methods: {
            editClicked () {
              this.$emit('edit', this.uploaded)
            },
            deleteClicked () {
              this.$emit('delete', this.uploaded)
            }
        }
    }
</script>

<style scoped>

</style>
